import { InputSelect } from '@insify/components';
import clsx from 'clsx';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import * as styles from './InputLanguageSelect.module.css';

import type { SupportedCountry } from '../../types/supported-countries';
import type React from 'react';
type Props = {
  className?: string;
};

type Language = SupportedCountry | 'en';

/**
 * @deprecated This component will be retired once complete transition to LanguageSelect is done
 *
 * A select input with barebones HTML select menu to change the language of the app
 */
export const InputLanguageSelect: React.FC<Props> = (props) => {
  const { i18n } = useTranslation();
  const { control } = useForm({
    defaultValues: {
      language: i18n.language,
    },
  });
  const options: { label: React.ReactNode; value: Language }[] = [
    {
      label: '🇩🇪 Deutsch',
      value: 'de',
    },
    {
      label: '🇳🇱 Nederlands',
      value: 'nl',
    },
    {
      label: '🇫🇷 Français',
      value: 'fr',
    },
    {
      label: '🇬🇧 English',
      value: 'en',
    },
  ];

  const selectLanguage = (lang: Language) => {
    return i18n.changeLanguage(lang);
  };
  /* TODO replace InputSelect with Select from the DS */
  return (
    <InputSelect
      className={clsx(styles.input, props.className)}
      onChange={selectLanguage}
      control={control}
      name='language'
      options={options}
    />
  );
};
